const React = require('react');
const upperFirst = require('mn-utils/upperFirst');
const {default: DateFnsUtils} = require('@date-io/date-fns');
const {DatePicker, MuiPickersUtilsProvider} = require('@material-ui/pickers');
const EventIcon = require('@material-ui/icons/Event').default;

const Ripple = require('../../../Ripple');
const useFormCtx = require('../../utils/useFormCtx');

module.exports = ({
  id: manualId,
  className,
  multiline,
  type,
  label: manualLabel,
  format = 'dd.mm.yyyy',
  views = [],
  disableFuture,
  minDate,
  maxDate,
  disableLabel,
  ...props
}) => {
  const {
    name,
    value,
    error,
    showError,
    onChange,
    disabled
  } = useFormCtx(props);

  const id = manualId || name;

  const label = disableLabel
    ? ''
    : manualLabel
      ? manualLabel
      : name
        ? name.split('_').map(upperFirst).join(' ')
        : '';

  return (
    <div
      className={'rlv pt10 pb18' + (className ? ` ${className}` : '')}
    >
      {label && (
        <label
          className="dB f12 fw4 pb14 ff$3"
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <div className="rlv">
        <MuiPickersUtilsProvider
          utils={DateFnsUtils}
        >
          <DatePicker
            id={id}
            margin="none"
            variant="dialog"
            inputVariant="outlined"
            format={format}
            views={views}
            value={value || null}
            disabled={disabled}
            disableFuture={disableFuture}
            minDate={minDate}
            maxDate={maxDate}
            onChange={(value) => {
              onChange(name, value)
            }}
            className={
              `w 
              (crP):h>.MuiInputBase-input
              (o50|bg0.25)>.MuiInputBase-root.Mui-disabled
              (crDefault):h>.Mui-disabled
              (bgF|b1|bs|bc0|r9)>.MuiInputBase-root
              (bcF00).error>.MuiInputBase-root
              (bc0|r9)>.MuiInputBase-root.Mui-focused
              (pr8)>.MuiOutlinedInput-adornedEnd
              (hmin45|pt12|ph25|pb15|bxzBB|f12|fw7|ff$3|dn)>.MuiInputBase-input
              (sr)>.MuiButtonBase-root
              (dN)>.MuiFormHelperText-root
              (bcTransparent)>.MuiOutlinedInput-notchedOutline
              (bcTransparent)>.MuiOutlinedInput-root:h>.MuiOutlinedInput-notchedOutline
              (bcTransparent)>.MuiInputBase-root.Mui-focused>.MuiOutlinedInput-notchedOutline
              (bcTransparent)>.MuiInputBase-root.Mui-error>.MuiOutlinedInput-notchedOutline`
                + (className ? ` ${className}` : '')
                + (showError ? ` error` : '')
                + (disabled ? ` disabled` : '')
            }
          />
          <Ripple
            className={
              `abs st50% xY-50% sr20 (dB)>svg (o50).disabled`
              + (disabled ? ' disabled' : '')
            }
            onClick={() => {
              const input = document.getElementById(id);
              if (input) input.click();
            }}
            disabled={disabled}
          >
            <EventIcon />
          </Ripple>
        </MuiPickersUtilsProvider>
      </div>
      {
        showError ? (
          <div className="abs sb0 sl">
            <span className="f11 cF00 fw4">
              {error || 'Invalid value'}
            </span>
          </div>
        ) : null
      }
    </div>
  );
};
